import { cmsGraphql } from '../lib/cms/index.js'

export const cmsCustomHeaderFragment = cmsGraphql(/* GraphQL */ `
  fragment cmsCustomHeaderFragment on CmsCustomHeader {
    isHidden
    headerDisplay
    loginLink {
      ...resolveHrefFragment
    }
    signupLink {
      ...resolveHrefFragment
    }
    supportLink {
      ...resolveHrefFragment
    }
  }
`)
